@if (viewPage) {
  <app-loading></app-loading>
}

<!-- บังคับล็อกอินก่อนตอบ (require_login) -->
@if (needLogin) {
  <div class="pv-state">
    <div class="pv-state-icon"><i class="pi pi-lock"></i></div>
    <h2 class="pv-state-title">แบบสอบถามนี้ต้องเข้าสู่ระบบก่อนตอบ</h2>
    <p class="pv-state-desc">กรุณาเข้าสู่ระบบเพื่อทำแบบสอบถาม (1 บัญชีตอบได้ 1 ครั้ง)</p>
    <div id="googleSignInBtn" class="d-flex justify-content-center mt-3"></div>
    <div class="pv-state-or">หรือ</div>
    <p-button label="เข้าสู่ระบบ" icon="pi pi-sign-in" styleClass="btn-primary" (click)="goLogin()"></p-button>
  </div>
}

<!-- ความยินยอมก่อนตอบ (require_consent) — ต้องอ่านและกดยอมรับก่อนถึงจะเห็น/ตอบคำถามได้ -->
@if (showConsentGate) {
  <div class="pv-state">
    <div class="pv-state-icon"><i class="pi pi-shield"></i></div>
    <h2 class="pv-state-title">ความยินยอม</h2>
    <p class="pv-state-desc consent-text">{{ formItem?.consent_text || 'กรุณายอมรับเพื่อดำเนินการต่อ' }}</p>
    <p-button label="ยอมรับและเริ่มทำแบบสอบถาม" icon="pi pi-check" styleClass="btn-primary" (click)="acceptConsent()"></p-button>
  </div>
}

<!-- เนื้อหา badge/ชื่อฟอร์ม/คำอธิบาย (+วันที่เฉพาะ largebackground) ของหน้าปก ใช้ร่วมกันทั้ง 2 จุดด้านล่าง (โหมดล็อกอินตอบทีเดียว / โหมดตอบทีละหน้า) -->
<ng-template #pvHeroContent>
  <span class="pv-hero-badge"><i class="fa-regular fa-clipboard"></i> แบบสอบถาม</span>
  <h1 class="pv-form-name" [innerHTML]="formItem.form_name"></h1>
  @if (formView.cover_layout === 'largebackground' && coverDateLabel) {
    <p class="pv-hero-date">{{ coverDateLabel }}</p>
  }
  @if (formItem.form_desc) {
    <p class="pv-form-desc" [innerHTML]="formItem.form_desc"></p>
  }
</ng-template>

@if (!viewPage && !needLogin) {
  <div class="page-shell pv-shell" [style.--pv-theme-bg]="formView.theme_color" [style.--pv-theme-bg-image]="formView.theme_bg_image ? 'url(' + resolveBgImageUrl(formView.theme_bg_image) + ')' : null" [style.--pv-theme-bg-position]="formView.theme_bg_position || 'center center'" [style.--pv-theme-font]="themeFontFamily(formView.theme_font)" [style.--pv-theme-tint]="themeTint(formView.theme_color)">
    <main class="page-main narrow">
      @if (view) {
        <header class="page-topbar sticky">
          <button type="button" class="page-back-btn" (click)="backPage()" aria-label="ย้อนกลับ">
            <i class="fa-solid fa-chevron-left"></i>
          </button>
          <div class="page-titles compact"><h1>ดูแบบสอบถาม</h1></div>
        </header>
      }
      <!-- ผู้ใช้ที่ล็อกอินตอบ (แสดงทุกหน้าในเอกสารเดียว) -->
      @if (!formSuccess && userid && !showConsentGate) {
        <div class="pv-doc-stack">
          <section class="pv-hero">
            <div class="pv-hero-cover" [ngClass]="'pv-hero-cover--' + (formView.cover_layout || 'largetitle')">
              <!-- largebalanced/largelightbalanced: กล่องเนื้อหาลอย / smallcard: แถบรูปเต็มด้านบน + เนื้อหาขาวเต็มความกว้างด้านล่าง -->
              <!-- ไม่แสดงรูปพื้นหลังธีมซ้ำในการ์ด hero — รูปแสดงเป็นพื้นหลังทั้งหน้าอยู่แล้วที่ .pv-shell ด้านบน -->
              @if (formView.cover_layout === 'largebalanced' || formView.cover_layout === 'largelightbalanced' || formView.cover_layout === 'smallcard') {
                <div class="pv-hero-media"
                [style.background-position]="formView.theme_bg_position || 'center center'"></div>
              }
              <!-- largebackground/paper: เนื้อหาอยู่ในการ์ดขาวลอย -->
              @if (formView.cover_layout === 'largebackground' || formView.cover_layout === 'paper') {
                <div class="pv-hero-card">
                  <ng-container *ngTemplateOutlet="pvHeroContent"></ng-container>
                </div>
              }
              <!-- largetitle (ค่าเริ่มต้น)/largebalanced/largelightbalanced/smallcard: เนื้อหาอยู่ตรงในการ์ดเลย -->
              @if (!formView.cover_layout || formView.cover_layout === 'largetitle' || formView.cover_layout === 'largebalanced' || formView.cover_layout === 'largelightbalanced' || formView.cover_layout === 'smallcard') {
                <div class="pv-hero-content">
                  <ng-container *ngTemplateOutlet="pvHeroContent"></ng-container>
                </div>
              }
            </div>
            <div class="pv-required-note"><span class="req">*</span> จำเป็นต้องตอบ</div>
          </section>
          @for (page of formItem.pages; track trackByIndex($index)) {
            @if (formItem.pages.length > 1 && page.page_name) {
              <div class="pv-page-head">
                <span class="pv-page-name" [innerHTML]="page.page_name"></span>
                @if (page.page_desc) {
                  <span class="pv-page-desc" [innerHTML]="page.page_desc"></span>
                }
              </div>
            }
            @for (form of page.questions; track trackByIndex(index); let index = $index) {
              @if (isQuestionVisible(form)) {
                <section class="pv-q-card">
                  @if (form.question_media_url) {
                    <div class="pv-q-media-wrap">
                      <img class="pv-q-media" [src]="resolveQuestionMediaUrl(form.question_media_url)" alt="" />
                    </div>
                  }
                  @if (form.question_type_id == formType.time) {
                    <app-form-time [model]="form"
                    (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-time>
                  }
                  @if (form.question_type_id == formType.datepicker) {
                    <app-form-date [model]="form"
                    (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-date>
                  }
                  @if (form.question_type_id == formType.short) {
                    <app-form-short [model]="form"
                    (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-short>
                  }
                  @if (form.question_type_id == formType.multiple) {
                    <app-form-multiple [model]="form"
                    (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-multiple>
                  }
                  @if (form.question_type_id == formType.long) {
                    <app-form-long [model]="form"
                    (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-long>
                  }
                  @if (form.question_type_id == formType.score) {
                    <app-form-score [model]="form"
                    (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-score>
                  }
                  @if (form.question_type_id == formType.single) {
                    <app-form-signle [model]="form"
                    (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-signle>
                  }
                  <!-- Dropdown (เลือกได้ข้อเดียว แสดงเป็น dropdown) -->
                  @if (form.question_type_id == formType.dropdown) {
                    <app-form-dropdown [model]="form"
                    (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-dropdown>
                  }
                  <!-- NPS (0–10) แสดงเป็นปุ่มคะแนนแนวนอนเหมือน score (ไม่เรียงตั้งให้ยืด) -->
                  @if (form.question_type_id == formType.nps) {
                    <app-form-score [model]="form"
                    (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-score>
                  }
                  <!-- Likert (เห็นด้วย–ไม่เห็นด้วย) ใช้ UI เลือกข้อเดียวร่วมกัน -->
                  @if (form.question_type_id == formType.likert && (!form.matrix_rows || form.matrix_rows.length <= 1)) {
                    <app-form-signle [model]="form"
                    (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-signle>
                  }
                  <!-- Matrix/Grid (หลายแถว x scale เดียวกัน) — ต่อยอดจาก likert -->
                  @if (form.question_type_id == formType.likert && form.matrix_rows && form.matrix_rows.length > 1) {
                    <app-form-matrix [model]="form"
                    (update)="updateMatrix(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-matrix>
                  }
                  <!-- File upload (รูปภาพ) -->
                  @if (form.question_type_id == formType.fileupload) {
                    <app-form-fileupload [model]="form"
                    (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-fileupload>
                  }
                </section>
              }
            }
          }
        </div>
      }
      <!-- ตอบผ่านลิงก์สาธารณะ (ทีละหน้า) -->
      @if (!userid && (formView.form || form_id) && (!formSuccess && formView.expire == false && key_id || !formSuccess && form_id) && !showConsentGate && !editLoading && !alreadyAnswered) {
        <div class="pv-doc-stack"
          >
          <!-- โหมดแก้ไขคำตอบเดิม: แจ้งเตือนผู้ตอบว่ากำลังแก้ไขคำตอบที่เคยส่งไปแล้ว -->
          @if (editMode) {
            <div class="pv-edit-banner">
              <i class="fa-solid fa-pen-to-square"></i>
              <span>คุณเคยตอบแบบสอบถามนี้แล้ว — กำลังแก้ไขคำตอบเดิม</span>
            </div>
          }
          <section class="pv-hero">
            <div class="pv-hero-cover" [ngClass]="'pv-hero-cover--' + (formView.cover_layout || 'largetitle')">
              <!-- largebalanced/largelightbalanced: กล่องเนื้อหาลอย / smallcard: แถบรูปเต็มด้านบน + เนื้อหาขาวเต็มความกว้างด้านล่าง -->
              <!-- ไม่แสดงรูปพื้นหลังธีมซ้ำในการ์ด hero — รูปแสดงเป็นพื้นหลังทั้งหน้าอยู่แล้วที่ .pv-shell ด้านบน -->
              @if (formView.cover_layout === 'largebalanced' || formView.cover_layout === 'largelightbalanced' || formView.cover_layout === 'smallcard') {
                <div class="pv-hero-media"
                [style.background-position]="formView.theme_bg_position || 'center center'"></div>
              }
              <!-- largebackground/paper: เนื้อหาอยู่ในการ์ดขาวลอย -->
              @if (formView.cover_layout === 'largebackground' || formView.cover_layout === 'paper') {
                <div class="pv-hero-card">
                  <ng-container *ngTemplateOutlet="pvHeroContent"></ng-container>
                </div>
              }
              <!-- largetitle (ค่าเริ่มต้น)/largebalanced/largelightbalanced/smallcard: เนื้อหาอยู่ตรงในการ์ดเลย -->
              @if (!formView.cover_layout || formView.cover_layout === 'largetitle' || formView.cover_layout === 'largebalanced' || formView.cover_layout === 'largelightbalanced' || formView.cover_layout === 'smallcard') {
                <div class="pv-hero-content">
                  <ng-container *ngTemplateOutlet="pvHeroContent"></ng-container>
                </div>
              }
            </div>
            <div class="pv-required-note"><span class="req">*</span> จำเป็นต้องตอบ</div>
          </section>
          @if (page > 1) {
            <div class="pv-progress-wrap">
              <div class="pv-progress-track">
                <div class="pv-progress-fill" [style.width.%]="((actionPage+1)/page)*100"></div>
              </div>
              <span class="pv-progress-label">หน้า {{actionPage+1}}/{{page}}</span>
            </div>
          }
          @if (page > 1 && pageItem.page_name) {
            <div class="pv-page-head">
              <span class="pv-page-name" [innerHTML]="pageItem.page_name"></span>
              @if (pageItem.page_desc) {
                <span class="pv-page-desc" [innerHTML]="pageItem.page_desc"></span>
              }
            </div>
          }
          @for (form of pageItem.questions; track trackByIndex($index)) {
            @if (isQuestionVisible(form)) {
              <section class="pv-q-card">
                @if (form.question_media_url) {
                  <div class="pv-q-media-wrap">
                    <img class="pv-q-media" [src]="resolveQuestionMediaUrl(form.question_media_url)" alt="" />
                  </div>
                }
                @if (form.question_type_id == formType.time) {
                  <app-form-time [model]="form"
                  (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-time>
                }
                @if (form.question_type_id == formType.datepicker) {
                  <app-form-date [model]="form"
                  (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-date>
                }
                @if (form.question_type_id == formType.short) {
                  <app-form-short [model]="form"
                  (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-short>
                }
                @if (form.question_type_id == formType.multiple) {
                  <app-form-multiple [model]="form"
                  (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-multiple>
                }
                @if (form.question_type_id == formType.long) {
                  <app-form-long [model]="form"
                  (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-long>
                }
                @if (form.question_type_id == formType.score) {
                  <app-form-score [model]="form"
                  (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-score>
                }
                @if (form.question_type_id == formType.single) {
                  <app-form-signle [model]="form"
                  (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-signle>
                }
                @if (form.question_type_id == formType.dropdown) {
                  <app-form-dropdown [model]="form"
                  (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-dropdown>
                }
                @if (form.question_type_id == formType.nps) {
                  <app-form-score [model]="form"
                  (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-score>
                }
                @if (form.question_type_id == formType.likert && (!form.matrix_rows || form.matrix_rows.length <= 1)) {
                  <app-form-signle [model]="form"
                  (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-signle>
                }
                @if (form.question_type_id == formType.likert && form.matrix_rows && form.matrix_rows.length > 1) {
                  <app-form-matrix [model]="form"
                  (update)="updateMatrix(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-matrix>
                }
                @if (form.question_type_id == formType.fileupload) {
                  <app-form-fileupload [model]="form"
                  (update)="updateValue(form,$event)" (valid)="updateValiDate(form,$event)"></app-form-fileupload>
                }
              </section>
            }
          }
          <div class="pv-actions">
            @if (actionPage > 0) {
              <p-button label="ย้อนกลับ" styleClass="btn-primary-line p-button-sm"
              (onClick)="back()"></p-button>
            }
            <span class="pv-actions-spacer"></span>
            @if (actionPage != lastVisiblePageIndex && !userid && !valid) {
              <p-button label="ต่อไป" styleClass="btn-primary p-button-sm"
              (onClick)="next()"></p-button>
            }
            @if (actionPage != lastVisiblePageIndex && valid && !userid) {
              <p-button label="ต่อไป" styleClass="btn-primary p-button-sm"
              (onClick)="alertMessage()"></p-button>
            }
            @if (actionPage == lastVisiblePageIndex && valid && !userid) {
              <p-button [label]="editMode ? 'บันทึกการแก้ไข' : 'ส่ง'" styleClass="btn-primary p-button-sm"
              (onClick)="alertMessage()"></p-button>
            }
            @if (actionPage == lastVisiblePageIndex && key_id && !valid && !form_id) {
              <p-button [label]="editMode ? 'บันทึกการแก้ไข' : 'ส่ง'" styleClass="btn-primary p-button-sm"
                [loading]="submitting" [disabled]="submitting"
              (onClick)="sendForm()"></p-button>
            }
          </div>
        </div>
      }
      <!-- ส่งสำเร็จ — ใช้สีธีมของลิงก์เผยแพร่ (ถ้าตั้งไว้) ให้ดูเป็นชุดเดียวกับตอนตอบ -->
      @if (formSuccess) {
        <div class="app-card pv-state pv-success">
          <div class="pv-success-icon"><i class="fa-solid fa-check"></i></div>
          <h2 class="pv-state-title">ขอบคุณ</h2>
          <p class="pv-state-desc">คำตอบของคุณสำหรับ@if (formItem?.form_name) {
            <strong>"{{stripHtml(formItem.form_name)}}"</strong>
          }ถูกบันทึกไว้แล้ว</p>
          <!-- ผลแบบทดสอบ (Quiz) — แสดงคะแนนรวม + เฉลยรายข้อ เฉพาะเมื่อ is_quiz -->
          @if (quizResult?.is_quiz) {
            <div class="pv-quiz">
              <!-- สรุปคะแนนรวม -->
              <div class="pv-quiz-summary">
                <div class="pv-quiz-score">
                  คะแนนของคุณ
                  <strong>{{ quizResult?.score ?? 0 }}</strong> / {{ quizResult?.max_score ?? 0 }}
                </div>
                <div class="pv-quiz-percent">{{ quizPercent }}%</div>
              </div>
              <!-- เฉลยรายข้อ -->
              <div class="pv-quiz-list">
                @for (q of quizResult?.questions; track trackByIndex(i); let i = $index) {
                  <div class="pv-quiz-item"
                    [class.is-correct]="q.is_correct" [class.is-wrong]="!q.is_correct">
                    <div class="pv-quiz-item-head">
                      <span class="pv-quiz-mark">
                        <i class="fa-solid" [class.fa-check]="q.is_correct" [class.fa-xmark]="!q.is_correct"></i>
                      </span>
                      <span class="pv-quiz-qname">{{ (i + 1) }}. {{ stripHtml(quizQuestionName(q.question_id)) }}</span>
                      <span class="pv-quiz-point">{{ q.earned }} / {{ q.point }}</span>
                    </div>
                    <div class="pv-quiz-answers">
                      <!-- คำตอบที่ผู้ตอบเลือก -->
                      <div class="pv-quiz-answer">
                        <span class="pv-quiz-answer-label">คำตอบของคุณ:</span>
                        @if (quizChoiceLabels(q.question_id, q.selected_choice_ids); as sel) {
                          @if (sel.length) {
                            <span>{{ sel.join(', ') }}</span>
                          }
                          @if (!sel.length) {
                            <span class="pv-quiz-empty">(ไม่ได้ตอบ)</span>
                          }
                        }
                      </div>
                      <!-- เฉลย (แสดงเมื่อตอบผิด) -->
                      @if (!q.is_correct) {
                        <div class="pv-quiz-answer pv-quiz-correct">
                          <span class="pv-quiz-answer-label">คำตอบที่ถูกต้อง:</span>
                          @if (quizChoiceLabels(q.question_id, q.correct_choice_ids); as cor) {
                            @if (cor.length) {
                              <span>{{ cor.join(', ') }}</span>
                            }
                            @if (!cor.length) {
                              <span class="pv-quiz-empty">-</span>
                            }
                          }
                        </div>
                      }
                    </div>
                    <!-- feedback ของข้อนี้ (ถ้ามี) -->
                    @if (q.feedback) {
                      <div class="pv-quiz-feedback">
                        <i class="fa-regular fa-comment-dots"></i>
                        <span>{{ q.feedback }}</span>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
          <p-button label="ตอบคำถามอีกครั้ง" styleClass="btn-primary-line mt-3" (click)="replay()"></p-button>
          <div class="pv-share">
            <span class="pv-share-label">แชร์แบบสอบถามนี้ต่อ</span>
            <div class="pv-share-actions">
              <button type="button" class="pv-share-btn pv-share-line" (click)="shareLine()" aria-label="แชร์ทาง LINE">
                <i class="fa-brands fa-line"></i>
              </button>
              <button type="button" class="pv-share-btn pv-share-facebook" (click)="shareFacebook()" aria-label="แชร์ทาง Facebook">
                <i class="fa-brands fa-facebook-f"></i>
              </button>
              <button type="button" class="pv-share-btn" (click)="copyShareLink()" aria-label="คัดลอกลิงก์">
                <i class="fa-regular fa-copy"></i>
              </button>
            </div>
          </div>
        </div>
      }
      <!-- เคยตอบแล้ว และลิงก์ไม่อนุญาตให้แก้ไขคำตอบ -->
      @if (alreadyAnswered && !formSuccess) {
        <div class="app-card pv-state pv-success">
          <div class="pv-success-icon"><i class="fa-solid fa-check"></i></div>
          <h2 class="pv-state-title">คุณได้ตอบแบบสอบถามนี้แล้ว</h2>
          <p class="pv-state-desc">ขอบคุณสำหรับการตอบแบบสอบถาม@if (formItem?.form_name) {
            <strong>"{{stripHtml(formItem.form_name)}}"</strong>
          } คุณได้บันทึกคำตอบไว้เรียบร้อยแล้ว</p>
        </div>
      }
      <!-- หมดเวลารับคำตอบ -->
      @if (formView.expire && key_id) {
        <div class="app-card pv-state">
          <img class="pv-state-img" src="../assets/img/warning.png" alt="">
          <h2 class="pv-state-title">แบบสอบถามนี้ไม่รับการตอบกลับอีกต่อไป</h2>
          <p class="pv-state-desc">โปรดติดต่อเจ้าของแบบสอบถามหากคุณคิดว่ามีข้อผิดพลาดเกิดขึ้น</p>
        </div>
      }
      <!-- ไม่พบแบบสอบถาม (เฉพาะลิงก์สาธารณะที่ไม่พร้อม, ไม่หมดอายุ, ยังไม่ส่ง) -->
      @if (key_id && !form_id && !userid && !formView.ready && !formView.expire && !formSuccess) {
        <div class="app-card pv-state"
          >
          <img class="pv-state-img" src="../assets/img/warning.png" alt="">
          <h2 class="pv-state-title">ไม่พบแบบสอบถามการประเมิน</h2>
          <p class="pv-state-desc">โปรดติดต่อเจ้าของแบบสอบถาม หากคุณคิดว่ามีข้อผิดพลาดเกิดขึ้น</p>
        </div>
      }
    </main>
  </div>
}



